var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNumber2Xs = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM11 12H5.07813V10.6094L7.9961 8.05469C8.65235 7.46484 9.02735 7.05859 9.02735 6.46094C9.02735 5.80078 8.5547 5.39844 7.90235 5.39844C7.23829 5.39844 6.79298 5.81641 6.79298 6.53906H4.96095C4.95704 4.91016 6.14063 3.89062 7.91017 3.89062C9.72657 3.89062 10.9024 4.86719 10.9024 6.30859C10.9024 7.22656 10.4492 7.99609 8.71485 9.50781L7.75782 10.3906V10.4414H11V12Z",
  fill: "currentColor"
})));
export { SvgNumber2Xs as ReactComponent };